import ResourceException from './ResourceException';
import queryString from 'query-string';

const HttpSuccessStatuses = [200, 201, 202, 203, 204];
const BASE_URL = 'https://dawa.aws.dk';
const BASE_CONFIG = {mode: 'cors'};

export default class DAWAResource {
    /**
     * Get all records from specific DAWA resource
     *
     * @param resource
     */
    static all(resource) {
        return fetch(`${BASE_URL}/${resource}`)
            .then(response => {
                if (HttpSuccessStatuses.indexOf(response.status) === -1) {
                    throw new ResourceException(`Server respond with error due to the status: ${response.status}`);
                }

                return response.json();
            });
    }

    /**
     * Get detail information from DAWA resource by id
     *
     * @param {String} resource
     * @param id
     */
    static get(resource, id) {

        let url = `${BASE_URL}/${resource}/${id}`;

        return fetch(url, BASE_CONFIG)
            .then(response => {
                if (HttpSuccessStatuses.indexOf(response.status) === -1) {
                    throw new ResourceException(`Server respond with error due to the status: ${response.status}`);
                }

                return response.json();
            });
    }

    /**
     * Search address by municipality id, region id and string(street name, city, post number)
     * By default search sting is empty
     *
     * @param municipalityId
     * @param regionId
     * @param searchString
     *
     * @return {Promise}
     */
    static addressSearch(municipalityId, regionId, searchString = '') {
        let url = `${BASE_URL}/adresser/autocomplete`;

        let searchQueryParam = {
            kommunekode: municipalityId,
            regionskode: regionId,
            multiline: true,
        };
        if(searchString !== '') {
            searchQueryParam.q = searchString;
        }

        if (Object.keys(searchQueryParam).length !== 0) {
            url = `${url}?${queryString.stringify(searchQueryParam)}`;
        }

        return fetch(url, BASE_CONFIG)
            .then(response => {
                if (HttpSuccessStatuses.indexOf(response.status) === -1) {
                    throw new ResourceException(`Server respond with error due to the status: ${response.status}`);
                }

                return response.json();
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/services/DAWAResource.js